<app-breadcrumb [title]="'Начало'" ></app-breadcrumb>
<!--<div>
  <button *ngIf="isRegisterSignalVisible()" class="btn btn-info"
          type="button"
          (click)="onCreation()">
    Регистрирай Сигнал
  </button>
</div>-->

<ng-container *ngIf="!isLoading">
  <!-- eGov Automation Dashboard -->
  <ng-container *ngIf="user.organization.enableEGovAutomation">
    <div class="container-fluid default-page">
      <!-- Date Range Filter -->
      <div class="row mb-3">
        <div class="col-12">
          <div class="filter-card">
            <span class="filter-label">От дата:</span>
            <input type="date"
                   class="form-control date-input"
                   [(ngModel)]="startDate"
                   [max]="endDate">

            <span class="filter-label">До дата:</span>
            <input type="date"
                   class="form-control date-input"
                   [(ngModel)]="endDate"
                   [min]="startDate">

            <button class="btn btn-dark" (click)="onDateRangeChange()">
              <i class="fa fa-filter"></i> Филтрирай
            </button>
            <button class="btn btn-outline-secondary" (click)="clearDateRange()">
              <i class="fa fa-refresh"></i> Изчисти
            </button>
          </div>
        </div>
      </div>

      <!-- Widgets -->
      <div class="row" style="justify-content:center; gap: 20px;">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
          <app-egov-services-requested [isRefreshed]="isWidgetRefreshed" [startDate]="startDate" [endDate]="endDate"></app-egov-services-requested>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
          <app-egov-taxes-collected [isRefreshed]="isWidgetRefreshed" [startDate]="startDate" [endDate]="endDate"></app-egov-taxes-collected>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
          <app-egov-taxes-paid [isRefreshed]="isWidgetRefreshed" [startDate]="startDate" [endDate]="endDate"></app-egov-taxes-paid>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
          <app-egov-taxes-unpaid [isRefreshed]="isWidgetRefreshed" [startDate]="startDate" [endDate]="endDate"></app-egov-taxes-unpaid>
        </div>
      </div>
      <div class="row" style="margin-top: 20px;">
        <div class="col-12">
          <app-egov-requests-table [isRefreshed]="isWidgetRefreshed" [startDate]="startDate" [endDate]="endDate"></app-egov-requests-table>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- VIK Module Dashboard -->
  <ng-container *ngIf="user.organization.enableVikModule">

    <!-- Dispecher-->
    <ng-container *ngIf="user.userProfessionIdUserProfession == 3">
      <div  class="container-fluid default-page">
        <div class="row" style="justify-content:center;">
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-total-new-signals  [isRefreshed]="isWidgetRefreshed" ></app-vik-total-new-signals>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-tr-total-obrabotka [isRefreshed]="isWidgetRefreshed"></app-vik-tr-total-obrabotka>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-total-signals [isRefreshed]="isWidgetRefreshed"></app-vik-total-signals>
          </div>
        </div>
        <div class="row" style="justify-content:center;">
          <app-signals-registration-list (isTableRefreshed)="onSignalsRefresh($event)" [isHeadless]="true " [isDashboardView]="true">

          </app-signals-registration-list>

        </div>
      </div>
    </ng-container>

    <!-- T. Rukovod-->
    <ng-container *ngIf="user.userProfessionIdUserProfession == 4">
      <div class="container-fluid default-page">
        <div class="row" style="justify-content:center;">
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-total-new-signals  [isRefreshed]="isWidgetRefreshed"></app-vik-total-new-signals>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-tr-total-obrabotka  [isRefreshed]="isWidgetRefreshed"></app-vik-tr-total-obrabotka>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-total-signals  [isRefreshed]="isWidgetRefreshed"></app-vik-total-signals>
          </div>
        </div>
        <div class="row" style="justify-content:center;">
          <app-signals-registration-list  (isTableRefreshed)="onSignalsRefresh($event)" [isHeadless]="true " [isDashboardView]="true">

          </app-signals-registration-list>

        </div>
      </div>

    </ng-container>

    <!-- Rukov Rem Grupa-->
    <ng-container *ngIf="user.userProfessionIdUserProfession == 5">
      <div class="container-fluid default-page">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mb-4">
            <button type="button"
                    class="btn btn-success btn-sm"
                    (click)="onAddNewEmergencyClicked()">
              <i class="fa fa-plus"></i> Регистрирай авария
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-total-new-signals  [isRefreshed]="isWidgetRefreshed"></app-vik-total-new-signals>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-tr-total-obrabotka  [isRefreshed]="isWidgetRefreshed"></app-vik-tr-total-obrabotka>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-total-signals  [isRefreshed]="isWidgetRefreshed"></app-vik-total-signals>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12 mr-4">
            <app-vik-total-avarii  [isRefreshed]="isWidgetRefreshed"></app-vik-total-avarii>
          </div>
        </div>
        <div class="row" style="justify-content:center;">
          <app-signals-registration-list  (isTableRefreshed)="onSignalsRefresh($event)" [isHeadless]="true " [isDashboardView]="true">
          </app-signals-registration-list>
        </div>
      </div>

    </ng-container>

  </ng-container>

  </ng-container>

<ng-container *ngIf="isLoading">
  <app-loader text="Моля изчакайте..."></app-loader>
</ng-container>
